<template>
  <vx-card v-show="isCardActiveLocal" title="iSpring Quiz Details" class="mb-4">
    <div class="vx-row">
      <div class="vx-col w-full">
        <table>
          <!-- <tr><td><p>Title:</p></td><td><p style="font-weight: 700">{{ quiz.title }}</p></td></tr>
          <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{ quizDescription }}</p></td></tr> -->
          <tr><td><p>Grade Type:</p></td><td><p :style="{ 'color': setColor(quizInfo.quizSettings.quizType == 'graded' ? true : false), 'font-weight': 700 }">{{ quizInfo.quizSettings.quizType == 'graded' ? 'Graded' : 'Survey' }}</p></td></tr>
          <tr v-if="quizInfo.quizSettings.quizType == 'graded'"><td><p>Total Marks:</p></td><td><p :style="{ 'font-weight': 700 }">{{ quizInfo.quizSettings.maxScore }}</p></td></tr>
          <tr v-if="quizInfo.quizSettings.quizType == 'graded'"><td><p>Pass Percentage:</p></td><td><p :style="{'font-weight': 700 }">{{ quizInfo.quizSettings.passingPercent > 0 ? quizInfo.quizSettings.passingPercent + '%' : 'N/A' }}</p></td></tr>
          <tr><td><p>Time Limit:</p></td><td><p :style="{ 'color': setColor(quizInfo.quizSettings.timeLimit), 'font-weight': 700 }">{{ quizInfo.quizSettings.timeLimit == 0 ? 'None' : quizInfo.quizSettings.timeLimit + ' minutes' }}</p></td></tr>
        </table>
      </div>
    </div>
    <div v-if="quizInfo.quizSettings.quizType == 'graded'">
      <vs-divider position="left-center"><strong>Summary</strong></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-full">
          <table>
            <tr v-if="newScore != quizInfo.summary.score"><td><p>Original Score:</p></td><td><p style="font-weight: 700">{{ quizInfo.summary.score }}</p></td></tr>
            <tr v-else><td><p>Score:</p></td><td><p style="font-weight: 700">{{ quizInfo.summary.score }}</p></td></tr>
            <tr v-if="newScore != quizInfo.summary.score"><td><p>New Score:</p></td><td><p style="font-weight: 700">{{ newScore }}</p></td></tr>

            <tr v-if="newScore != quizInfo.summary.score"><td><p>Original Percentage:</p></td><td><p style="font-weight: 700">{{ quizInfo.summary.percent }}%</p></td></tr>
            <tr v-else><td><p>Percentage:</p></td><td><p style="font-weight: 700">{{ quizInfo.summary.percent }}%</p></td></tr>
            <tr v-if="newScore != quizInfo.summary.score"><td><p>New Percentage:</p></td><td><p style="font-weight: 700">{{ (newScore*100)/quizInfo.quizSettings.maxScore }}%</p></td></tr>

            <tr><td><p>Status:</p></td><td><p :style="{ 'color': setPassColor(quizInfo.summary.passed), 'font-weight': 700 }">{{ quizInfo.summary.passed ? 'Passed' : 'Failed' }}</p></td></tr>
            <tr><td><p>Time Finished:</p></td><td><p style="font-weight: 700">{{ quizInfo.summary.finishTimestamp }}</p></td></tr>
          </table>
        </div>
      </div>
    </div>
    <div>
      <vs-divider></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-full">
          <table>
            <tr><td><p>Assessed By:</p></td><td><p style="font-weight: 700">{{ quizInfo.summary.assessedBy }}</p></td></tr>
            <tr><td><p>Assessed On:</p></td><td><p style="font-weight: 700">{{ quizInfo.summary.assessedOn.replace("T", " ").split('.')[0] }}</p></td></tr>
          </table>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
  export default {
    components: {
      
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      quizInfo: {
        type: Object,
        required: false
      },
      newScore: {
        type: Number,
        required: false
      },
    },
    data() {
      return {
        quizDescription: ""
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setColor(val) {
        if(val){
          return 'green';
        }
        else{
          return 'orange';
        }
      },
      setPassColor(val) {
        if(val){
          return 'green';
        }
        else{
          return 'red';
        }
      },
      setOptionFont(optionIndex, option, answer) {
        if((optionIndex + 1) == answer.inputAnswer && answer.inputAnswer == option.optionNumber.toString())
          return 700;
        else if((optionIndex + 1) == answer.inputAnswer && answer.inputAnswer != option.optionNumber.toString())
          return 700;
        else
          return 400;
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
    },
    mounted() {
      if(this.quiz){
        this.quizDescription = this.strip(this.quiz.description);
      }
    }
  }

</script>

<style lang="scss">

</style>
